module.exports = __webpack_public_path__ + "img/credit-card-check.3d1d2cf5.svg";